<template>
  <div class="popup-wa" v-if="sosmed">
    <a title="'Hubungi Admin '"
      :href="`https://api.whatsapp.com/send?phone=62${sosmed.whatsapp}&text=Halo+Admin+saya+ingin+bertanya`"
      class="float" target="_blank">
      <font-awesome-icon icon="fa-brands fa-whatsapp " class="my-float" />
    </a>
  </div>
</template>
<script>
import api from "@/api";

export default {
  name: "PopupComponent",
  data() {
    return {
      sosmed: null,
    };
  },
  async mounted() {
    const whatsapp = sessionStorage.getItem("whatsapp");
    if (whatsapp) {
      this.sosmed = { whatsapp };
    } else {
      try {
        const response = await api.get("Content/sosmed");
        const fetchedWhatsapp = response.data.data[0].whatsapp;
        if (fetchedWhatsapp) {
          this.sosmed = { whatsapp: fetchedWhatsapp };
          sessionStorage.setItem("whatsapp", fetchedWhatsapp);
        }
      } catch (error) {
        // Handle error if needed
      }
    }
  }
};
</script>

<style></style>
